(() => {
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-l4m-cart-upsell-form]');
    if (!form) return;

    event.preventDefault();
    if (form.dataset.loading === 'true') return;

    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-l4m-cart-upsell-error]');
    form.dataset.loading = 'true';
    if (button) button.disabled = true;
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin',
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item to cart.');
      window.location.reload();
    } catch (err) {
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
      form.dataset.loading = 'false';
      if (button) button.disabled = false;
    }
  });
})();
